import Immutable from 'immutable';
import { COLLECTION_SHAPE } from '../../../config/shapes';
import {
  CLEAR_SEAT_MAP_ELEMENT,
  CLEAR_SEAT_MAP_ELEMENTS,
  FLAG_GETTING_SEAT_MAP_ELEMENT,
  FLAG_GETTING_SEAT_MAP_ELEMENTS,
  GET_SEAT_MAP_ELEMENT,
  GET_SEAT_MAP_ELEMENTS,
} from '../../../actions/types';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_GETTING_SEAT_MAP_ELEMENTS:
      return state.setIn(['all', 'loading'], payload);
    case GET_SEAT_MAP_ELEMENTS:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_SEAT_MAP_ELEMENTS:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_GETTING_SEAT_MAP_ELEMENT:
      // raising flag
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }
      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_SEAT_MAP_ELEMENT:
      return state.setIn(['current', 'content'], Immutable.Map(payload));
    case CLEAR_SEAT_MAP_ELEMENT:
      return state.setIn(['current', 'content'], INITIAL_STATE.getIn(['current', 'content']));
    default:
      return state;
  }
};
